interface OfuscateEmailProps {
    email?: string;
}

/**
 * Removes characters from emails in order to secure them
 * from being shown in screens while handling login processes.
 * 0-3 characters > only first character is shown
 * 4-6 characters > only first an last character is shown
 * 7+ characters > only first 2 an last 2 characters are shown
 *
 * @param email: string  The original email to be changed
 *
 * @return {string} The ofuscated email
 */
export const ofuscateEmail = ({ email = '' }: OfuscateEmailProps) => {
    let ofuscatedEmail = '';
    const [emailUser, emailDomain] = email.split('@');
    const emailUserLength = emailUser.length;

    if (emailUser && emailDomain) {
        if (emailUserLength < 4) {
            ofuscatedEmail = `${emailUser[0]}..@${emailDomain}`;
        } else if (emailUserLength < 7) {
            ofuscatedEmail = `${emailUser[0]}..${
                emailUser[emailUserLength - 1]
            }@${emailDomain}`;
        } else {
            ofuscatedEmail = `${emailUser.substring(
                0,
                2,
            )}..${emailUser.substring(
                emailUserLength - 2,
                emailUserLength,
            )}@${emailDomain}`;
        }
    }

    return ofuscatedEmail;
};
